var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VApp',[_c('VMain',{staticStyle:{"background":"#EEF3FA"}},[_c('div',{staticClass:"mx-sm-2 mx-md-7"},[_c('VContainer',[_vm._t("default")],2)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }